export default "__VITE_ASSET__Dj$uwTmT__"